import React, { FC } from 'react'
import { Trans } from '@lingui/macro'
import {
  Switch,
  Spinner,
  DrawerItem,
  DrawerItemHeader
} from 'front-end/src/components'
import { TopicModelAsEditor } from 'front-end/src/graphql/private/PrivateSchemaTypes'

import { useTopicForEditQuery } from '../../../topic-edit-page/TopicEditPage'
import IconBubble from '../../../../components/common/icon/IconBubble'
import { usePatchTopicMutation } from './ResourceDrawer.codegen'

const SetAllowComments: FC = () => {
  const [patchTopic] = usePatchTopicMutation()
  const { data, loading, refetch } = useTopicForEditQuery()

  if (loading) {
    return <Spinner />
  }

  const topic = data?.topic as TopicModelAsEditor
  const toggleAllowComments = async () => {
    const { data } = await patchTopic({
      variables: {
        topicId: topic.id,
        input: {
          allow_comments: !topic.allow_comments
        }
      }
    })

    if (data?.topic) {
      const { topic: resultTopic } = data
      if (resultTopic?.__typename === 'TopicModelAsEditor') {
        refetch()
      }
    }
  }

  return (
    <DrawerItem isInline py="16px">
      <DrawerItemHeader dataTest="AllowCommentsDrawer" mb={0}>
        <IconBubble />
        <Trans>Allow comments</Trans>
      </DrawerItemHeader>

      <Switch
        dataTest="AllowCommentsSwitch"
        onChange={toggleAllowComments}
        isChecked={!!topic.allow_comments}
      />
    </DrawerItem>
  )
}

export default SetAllowComments
